import React, { useState, useEffect } from "react";
import keycloak from "./keycloak";
import AuthSplash from "components/AuthSplash";

const KeycloakContext = React.createContext();

export const KeycloakProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let refreshInterval;

    keycloak
      .init({
        onLoad: "login-required",
        checkLoginIframe: false
      })
      .then((auth) => {
        setAuthenticated(auth);

        // Refresh shortly before expiry so table/data calls keep working.
        if (auth) {
          keycloak.onTokenExpired = () => {
            keycloak.updateToken(0).catch((error) => {
              console.log("keycloak onTokenExpired refresh error", error);
            });
          };

          refreshInterval = setInterval(() => {
            keycloak.updateToken(60).catch((error) => {
              console.log("keycloak token refresh error", error);
            });
          }, 30000);
        }
      })
      .catch((error) => {
        console.log("keycloak login error", error);
        // If init fails with stale redirect params in the URL, strip them
        // and reload so Keycloak can start a clean login-required flow.
        const cleanUrl = window.location.origin + '/';
        if (window.location.href !== cleanUrl) {
          window.location.replace(cleanUrl);
        } else {
          setAuthenticated(false);
        }
      });

    return () => {
      keycloak.onTokenExpired = undefined;
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    };
  }, []);

  if (!authenticated) {
    return <AuthSplash />;
  }

  return (
    <KeycloakContext.Provider value={{ keycloak }}>
      {children}
    </KeycloakContext.Provider>
  );
};

export default KeycloakContext;
